import PropTypes from 'prop-types'
import React from 'react'
import moment from 'moment-timezone'
import BookingAutoComplete from './BookingAutoComplete'

const ManualTimeFields = ({ start, end, autoCompleteOnChange, startTimes, endTimes, className }) => {
  return (
    <div className={className}>
      <BookingAutoComplete
        labelText={`start - (${moment(start, 'hh:mm').format('h:mm a')})`}
        hintText="e.g. 7:10 am"
        autoCompleteOnChange={autoCompleteOnChange}
        dataSource={startTimes.map(time => ({
          text: time.format('h:mm a'),
          value: time.format('H:mm'),
        }))}
      />
      <BookingAutoComplete
        labelText={`end - (${moment(end, 'hh:mm').format('h:mm a')})`}
        hintText="e.g. 5:55 pm"
        autoCompleteOnChange={autoCompleteOnChange}
        dataSource={endTimes.map(time => ({
          text: time.format('h:mm a'),
          value: time.format('H:mm'),
        }))}
      />
    </div>
  )
}

ManualTimeFields.propTypes = {
  start: PropTypes.string.isRequired,
  end: PropTypes.string.isRequired,
  autoCompleteOnChange: PropTypes.func.isRequired,
  startTimes: PropTypes.arrayOf(PropTypes.object).isRequired,
  endTimes: PropTypes.arrayOf(PropTypes.object).isRequired,
  className: PropTypes.string,
}

export default ManualTimeFields



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/BookingsCalendar/BookingPopover/ManualTimeFields.js